module.exports = __webpack_public_path__ + "img/money-fund-sparkling-dime.7b1b433f.svg";